import { render, staticRenderFns } from "./TaxAndGen2Dialog.vue?vue&type=template&id=6b702cda&"
import script from "./TaxAndGen2Dialog.vue?vue&type=script&lang=js&"
export * from "./TaxAndGen2Dialog.vue?vue&type=script&lang=js&"
import style0 from "./TaxAndGen2Dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports